var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen',{staticClass:"steps-view",staticStyle:{"background":"transparent","box-shadow":"none"},attrs:{"size":"large"}},[_c('div',{style:({
			justifyContent: 'center',
			alignItems: 'center',
			display: 'flex',
			flexDirection: 'column',
			position: 'relative'
		})},[_c('h1',[_vm._v("Settings a few things up... one moment please")]),_c('loader',{style:({ position: 'inherit', height: '55px' }),attrs:{"loading":true,"size":"big"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }